var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11063 7.00079C6.01266 8.04579 5.94391 9.89516 6.56094 10.6824C6.56094 10.6824 6.27047 8.65079 8.87438 6.10188C9.92281 5.07579 10.1652 3.68016 9.79906 2.63344C9.5911 2.04047 9.21125 1.55063 8.88125 1.2086C8.68875 1.00751 8.83656 0.675787 9.11672 0.687818C10.8114 0.763443 13.558 1.23438 14.725 4.16313C15.2372 5.44876 15.275 6.77735 15.0309 8.12829C14.8763 8.9911 14.3263 10.9092 15.5809 11.1447C16.4764 11.3131 16.9095 10.6016 17.1038 10.0894C17.1845 9.87626 17.4647 9.82298 17.6159 9.99313C19.1284 11.7136 19.2573 13.74 18.9445 15.4845C18.3395 18.8567 14.9244 21.3111 11.5316 21.3111C7.29313 21.3111 3.91922 18.8859 3.04438 14.4963C2.69203 12.7242 2.87078 9.21798 5.6036 6.74298C5.80641 6.55735 6.13813 6.72235 6.11063 7.00079Z",
    fill: "url(#paint0_radial_1401_4533)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0805 13.3065C11.5182 11.2956 12.2177 9.00104 12.601 8.08666C12.6526 7.96635 12.5151 7.85291 12.4068 7.92682C11.7348 8.38401 10.358 9.45994 9.71695 10.9742C8.84899 13.0212 8.91086 14.0232 9.42477 15.247C9.73414 15.9843 9.37492 16.1407 9.19445 16.1682C9.01914 16.1957 8.85758 16.0788 8.72867 15.9568C8.3579 15.6007 8.09365 15.1484 7.96555 14.6506C7.93805 14.544 7.79883 14.5148 7.73523 14.6024C7.25398 15.2676 7.00477 16.3349 6.99273 17.0895C6.95492 19.4218 8.88164 21.3124 11.2123 21.3124C14.1496 21.3124 16.2895 18.064 14.6016 15.3484C14.1118 14.5578 13.6512 14.0404 13.0805 13.3065Z",
    fill: "url(#paint1_radial_1401_4533)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1401_4533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6921 21.3645) rotate(-179.751) scale(12.1323 19.9066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1401_4533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3738 9.29123) rotate(90.5787) scale(12.6941 9.55324)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFF176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF27D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#FFF48F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FFF7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#FFF8BD",
    stopOpacity: 0.804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FFF6AB",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFF38D",
    stopOpacity: 0.209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FFF176",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fire_icon.240acc43ff3f6f1afaacacc3d45deb4b.svg";
export { ForwardRef as ReactComponent };